import { useMemo } from 'react';
import { useLocale } from './useLocale';
import {
  formatTokens,
  formatMultiplier,
  formatPercent,
  formatDate,
  formatTime,
  formatInteger,
  type TokenFormatOptions,
} from './format';

/** Formatters bound to the current URL locale. */
export function useFormat() {
  const locale = useLocale();
  return useMemo(
    () => ({
      locale,
      tokens: (n: number, o?: TokenFormatOptions) => formatTokens(n, locale, o),
      mult: (x: number) => formatMultiplier(x, locale),
      pct: (ratio: number, decimals?: number) => formatPercent(ratio, locale, decimals),
      int: (n: number) => formatInteger(n, locale),
      date: (d: Date | string | number, o?: Intl.DateTimeFormatOptions) => formatDate(d, locale, o),
      time: (d: Date | string | number) => formatTime(d, locale),
    }),
    [locale],
  );
}
